'use client'
import StarIcon from '@/icons/font-awesome/sharp-solid/star.svg'

interface HotelRatingRatingItemProps {
  rating: number
  text: string
  headline: string
}

export function HotelRatingRatingItem(props: HotelRatingRatingItemProps) {
  return (
    <>
      {(props.rating > 0 || props.text) && (
        <div>
          <div className="mb-4 mt-4 flex items-center gap-2 pt-10 text-2xl font-bold lg:text-base">
            <div className=" flex h-6 w-11 items-center justify-center rounded-md bg-primary pr-1 text-white">
              <div className="flex items-center justify-center gap-1">
                <StarIcon className={`h-4 w-4 rounded-md fill-primary-complement`} />
                <span className="mt-0 text-md font-bold">
                  {props.rating > 0 ? props.rating : '-'}
                </span>
              </div>
            </div>
            <p className="text-md text-stone-900 sm:text-xl">{props.headline}</p>
          </div>
          {props.text && <p className="text-sm text-stone-800">{props.text}</p>}
        </div>
      )}
    </>
  )
}
